import { NavLink } from "react-router-dom";
import WWLogoSymbol from "../assets/logos/ww_logo_symbol.svg?react";

const Footer = () => {
  let date = new Date();
  let year = date.getFullYear();

  return (
    <footer className="bg-primary-dark pt-12 pb-6 sm:px-6">
      <div className="outer-container container grid grid-cols-12 gap-6 pb-8 border-b border-white/10">
        <div className="col-span-12 lg:col-span-4 flex items-center justify-center lg:justify-start gap-2">
          {/* Brand mark, not a "current section" link like the nav items
              below it - a plain function className (rather than a string)
              opts out of NavLink's automatic active/pending class, so it
              never picks up the .active underline styling even on "/". */}
          <NavLink to="/" className={() => "group flex items-center gap-2 "}>
            <span className="w-8">
              <WWLogoSymbol />
            </span>
            <span className="transition-all ease-in-out duration-300 no-underline group-hover:underline group-hover:underline-offset-3  font-work-sans font-medium text-lg text-primary-light">
              Women Wavemakers
            </span>
          </NavLink>
        </div>
        <div className="col-span-12 lg:col-span-8 flex flex-wrap justify-center lg:justify-end gap-x-12 gap-y-6 text-left">
          <div>
            <h3 className="font-work-sans font-medium text-base uppercase tracking-wide text-white mb-3">
              Shop
            </h3>
            <NavLink
              to="/shop"
              className="block hover:underline hover:underline-offset-3 font-source-sans font-light text-base text-primary-light/80 hover:text-primary-light mb-2"
            >
              All Products
            </NavLink>
          </div>
          <div>
            <h3 className="font-work-sans font-medium text-base uppercase tracking-wide text-white mb-3">
              Company
            </h3>
            <NavLink
              to="/about"
              className="block hover:underline hover:underline-offset-3 font-source-sans font-light text-base text-primary-light/80 hover:text-primary-light mb-2"
            >
              About
            </NavLink>
            <NavLink
              to="/faq"
              className="block hover:underline hover:underline-offset-3 font-source-sans font-light text-base text-primary-light/80 hover:text-primary-light mb-2"
            >
              FAQs
            </NavLink>
            <NavLink
              to="/contact"
              className="block hover:underline hover:underline-offset-3 font-source-sans font-light text-base text-primary-light/80 hover:text-primary-light mb-2"
            >
              Contact
            </NavLink>
          </div>
          <div>
            <h3 className="font-work-sans font-medium text-base uppercase tracking-wide text-white mb-3">
              Legal
            </h3>
            <NavLink
              to="/privacy-policy"
              className="block hover:underline hover:underline-offset-3 font-source-sans font-light text-base text-primary-light/80 hover:text-primary-light mb-2"
            >
              Privacy Policy
            </NavLink>
          </div>
        </div>
      </div>
      <div className="outer-container container flex flex-wrap items-center justify-center lg:justify-between gap-2 pt-6">
        <span className="font-source-sans font-light text-base text-primary-light/80">
          &copy; {year} Women Wavemakers
        </span>
        <span className="font-source-sans font-light text-base text-primary-light/80">
          Fulfilled by Printful &middot; Payments by Stripe
        </span>
      </div>
    </footer>
  );
};

export { Footer };
